import React from "react";
import { Box } from "@mui/material";
import { AbortCampaign } from "./AbortCampaign";
import { PauseCampaign } from "./PauseCampaign";
import DownloadIcon from "../../../../constants/icons/DownloadIcon";
import { Button, useToast } from "@foundit/ui-library";
import { useSelector } from "react-redux";
import { inventoryUsageSelector, mailStripSelector } from "../../../../redux/selectors/campaignSetup.selector";
import { useTopUpMutation } from "../../../../redux/services/campaignListingService";
import ContactIcon from "../../../../constants/icons/ContactIcon";
import EmailIconNew from "../../../../constants/icons/EmailIconNew";
import { ConfigureMailDataType } from "../../../../types/dataTypes";

interface IProps {
  campaignId: string;
  campaignName: string;
  handleDownload: ({ campaignId }: { campaignId: string }) => void;
  status: string;
  rawStatus: string;
  isWhatsAppCampaign: boolean;
  bannerRef: any;
  mailStripData?: ConfigureMailDataType
}

const ActionsMenu: React.FC<IProps> = ({
  handleDownload,
  campaignId,
  campaignName,
  status,
  rawStatus,
  isWhatsAppCampaign,
  bannerRef,
  mailStripData
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const [triggerTopUp, {isLoading:triggerTopUpLoading}] = useTopUpMutation();
  const {inventoryUsage} = useSelector(inventoryUsageSelector);
  const { showToast } = useToast();
  

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDownloadCampaign = () => {
    // handleClose();
    handleDownload({ campaignId });
  };
  const hideOpt = ["live", "draft", "finished"];
  const showContactCS = status?.toLowerCase()?.includes("low credits") && inventoryUsage?.isLimitReached;

  const showVerifyEmail = status
    ?.toLowerCase()
    ?.includes("email not verified") && !!mailStripData?.redirectionalLink;

  const handleVerifyEmail = () => {
    if (mailStripData?.redirectionalLink)
      window.open(mailStripData?.redirectionalLink, "_blank");
  }

  const handleContactCS = async () => {
  try {
    await triggerTopUp({
      type: "Outreach",
      outreachNudge: bannerRef?.current?.innerText ?? "",
    }).unwrap();

    showToast({
      message: "Your request has been submitted.",
      type: "success",
      position: "bottom-left",
    });
  } catch (error) {
    showToast({
      message: "Something went wrong. Please try again later.",
      type: "error",
      position: "bottom-left",
    });
  }
};

  return (
    <Box sx={{ display: "flex", gap: "12px" }}>
      {!isWhatsAppCampaign && (
        <>
          {showContactCS && (
            <Button type="text" size="small" onClick={handleContactCS} startIcon={<ContactIcon />} loading={triggerTopUpLoading}>
              Contact CS
            </Button>
          )}

          {showVerifyEmail && (
            <Button type="text" size="small" onClick={handleVerifyEmail} startIcon={<EmailIconNew />}>
              Verify Email
            </Button>
          )}

          {!showVerifyEmail && !showContactCS && (
              <PauseCampaign
                campaignId={campaignId}
                status={status}
                 rawStatus={rawStatus}
                campaignName={campaignName}
              />
          )}

          {!hideOpt.includes(rawStatus?.toLowerCase()) && (
              <AbortCampaign
                campaignId={campaignId}
                status={status}
                campaignName={campaignName}
                rawStatus={rawStatus}
              />
          )}
        </>
      )}

      {isWhatsAppCampaign && status?.toLowerCase() !== "draft" && (
        <Button
          onClick={handleDownloadCampaign}
          type="text"
          size="small"
          startIcon={<DownloadIcon />}
        >
          Download replies
        </Button>
      )}
    </Box>
  );

  // return (
  //   <>
  //     <IconButton onClick={handleClick} disableRipple>
  //       <MoreVertIcon />
  //     </IconButton>

  //     <Menu
  //       id="campaignActions"
  //       aria-labelledby="campaign-actions"
  //       anchorEl={anchorEl}
  //       open={open}
  //       onClose={handleClose}
  //       anchorOrigin={{
  //         vertical: "top",
  //         horizontal: "right",
  //       }}
  //       transformOrigin={{
  //         vertical: "top",
  //         horizontal: "right",
  //       }}
  //       slotProps={{
  //         paper: {
  //           variant: "outlined",
  //           sx: {
  //             mt: 3,
  //           },
  //         },
  //       }}
  //     >
  //       {!isWhatsAppCampaign && (
  //         <>
  //           <MenuItem
  //             sx={{ color: COLOR_MAP.DARK_PURPLE, padding: "0.8rem 1.6rem !important"}}
  //             disabled={!showPause}
  //           >
  //             <PauseCampaign campaignId={campaignId} status={status} campaignName={campaignName} />
  //           </MenuItem>

  //           {!hideOpt.includes(status) &&
  //           <div style={{borderBottom: "1px solid #E8E8EB", margin: "0.8rem 1.6rem"}}></div>}

  //           {!hideOpt.includes(status) &&
  //             <MenuItem
  //             sx={{ color: COLOR_MAP.DARK_PURPLE, padding: "0.8rem 1.6rem !important"}}
  //             disabled={!showAbort}
  //           >
  //             <AbortCampaign campaignId={campaignId} status={status} campaignName={campaignName} />
  //           </MenuItem>}
  //         </>
  //       )}
  //       {isWhatsAppCampaign && (
  //         <MenuItem
  //           onClick={handleDownloadCampaign}
  //           sx={{ color: COLOR_MAP.DARK_PURPLE, padding: "0.8rem 1.6rem !important", width:"202px" }}
  //           disabled={status?.toLowerCase() === "draft"}
  //         >
  //           <Box sx={{ mr: 1, display: "flex", alignItems: "center" }}>
  //             <DownloadIcon />
  //           </Box>{" "}
  //           Download replies
  //         </MenuItem>
  //       )}
  //     </Menu>
  //   </>
  // );
};

export default ActionsMenu;
